import {createButton} from '@shared-web/components/core/button';
import {createDataStore} from '@shared-web/lib/data_store';
import {createTheme} from '@shared-web/theme/theme_base';
import {FrontendTheme} from '@shared-web/theme/theme_model';
import {textColor} from '@shared-web/theme/theme_utils';

export const Palette = {
  primaryColor: '#c1ddd8',
  background1: '#fde2d5',
  background2: 'linear-gradient(150deg, #fde2d5 0%, #fde2d5 40%, #e2b5a0 100%)',
  secondaryColor: '#5c4c44',
};

export const lightTheme: FrontendTheme = createTheme(
  {accentColor: Palette.primaryColor, dark: false},
  {
    main: {
      fontSize: 'inherit',
      backgroundColor: Palette.background2,
    },
    button: {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      paddingTop: '0.75rem',
      paddingRight: '1.5rem',
      paddingBottom: '0.75rem',
      paddingLeft: '1.5rem',
      ...textColor('#00000075'),
    },
    input: {
      fontSize: '1.5rem',
      fontWeight: 500,
      paddingRight: '1rem',
      paddingLeft: '1rem',
      height: '4rem',
      borderWidth: '0.4rem',
      focusBorderWidth: '0.4rem',
      placeholderColor: '#ccc',
      placeholderFontSize: '1.3rem',
    },
  }
);

const themeDataStore = createDataStore<FrontendTheme>(lightTheme);
export const getThemeData = themeDataStore.getData;
export const setThemeData = themeDataStore.setData;
export const useThemeData = themeDataStore.useData;

export const LargeNavButton = createButton({
  type: 'NavLink',
  theme: 'button',
  themeOverrides: {
    fontSize: '1.5rem',
    paddingTop: '1rem',
    paddingRight: '2rem',
    paddingBottom: '1rem',
    paddingLeft: '2rem',
  },
});
